import './ownerreviews.scss';
import {CarouselUtils} from '../../Shared/Assets/carousel-utils';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
Swiper.use([Navigation, Pagination]);

import '@csn-theme/star-rating';
import '@csn-theme/star-rating/dist/StarRating.css';

class OwnerReviews {
	init() {
		const sectionEl = document.querySelector('[data-role="ownerreviews-carousel-section"]');
		if (CarouselUtils.isMobile()) {
			sectionEl.classList.add('has-touch');
		} else {
			sectionEl.classList.remove('has-touch');
		}
		this.buildCarousel(sectionEl);
	}
	buildCarousel(sectionEl) {
		const swiperSectionEl = sectionEl.querySelector('[data-role="swiper-section"]');
		const configs = this.getCarouselConfigs(sectionEl,swiperSectionEl);
		const swiperEl = swiperSectionEl.querySelector('[data-role="swiper"]');
		new Swiper(swiperEl,configs);
	}
	getCarouselConfigs(sectionEl,swiperSectionEl) {
		if (CarouselUtils.isMobile()) {
			const slidesOffset = CarouselUtils.getSlidesOffset(sectionEl);
			const spaceBetween = 8;
			const slides = 1;
			return {
				edgeSwipeDetection: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				roundLengths: true,

				//responsive
				slidesPerView: slides,
				spaceBetween,
				slidesOffsetBefore: slidesOffset,
				slidesOffsetAfter: slidesOffset
			}
		}

		//desktop
		const pagination = CarouselUtils.usePagination(swiperSectionEl);
		const navigation = CarouselUtils.useNavs(swiperSectionEl, CarouselUtils.isLargeScreen());
		return {
			//https://swiperjs.com/swiper-api
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			roundLengths: true,
			speed:500,

			//responsive
			slidesPerView: 2,
			spaceBetween: 16,
			pagination,
			navigation,
			breakpoints: {
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4
				}
			},
		}
	}
}

window.addEventListener("load", () => new OwnerReviews().init());